import * as React from 'react';
import { UsdValue } from 'components/UsdValue';

type TotalAssetValueProps = {
  value: number;
};

export const AssetUsdValue = ({ value }: TotalAssetValueProps) => {
  return (
    <div className='inline-flex flex-row items-center gap-2'>
      <UsdValue
        symbolClassName='text-[0.75rem] leading-[1.125rem] lg:text-[1.25rem] lg:leading-[1.875rem]'
        valueClassName='text-[2rem] leading-[2.5rem] text-[#F7F8F8] lg:text-[2rem] lg:leading-[3.75rem]'
        value={value}
        format={{ minimumFractionDigits: 2, maximumFractionDigits: 6 }}
      />
    </div>
  );
};
